const productImages = [
  { url: "/gallery/cheesecake.jpg", alt: "Cheesecake" },
  { url: "/gallery/pistachio_latte.jpg", alt: "Pistachio latte" },
  { url: "/gallery/burger.jpg", alt: "Burger" },
  { url: "/gallery/croissant.jpg", alt: "Croissant" },
  { url: "/gallery/bowl.jpg", alt: "Rice bowl" },
  { url: "/food/sandwich.jpg", alt: "Grilled sandwich" },
  { url: "/food/breakfast.jpg", alt: "Breakfast platter" },
  { url: "/food/english.jpg", alt: "English breakfast" },
  { url: "/food/protein.jpg", alt: "Protein bowl" },
  { url: "/food/choco.jpg", alt: "Chocolate dessert" },
  { url: "/food/dish1.jpg", alt: "Kiplings dish" },
  { url: "/food/platter.jpg", alt: "Kiplings platter" },
  { url: "/food/creation.jpg", alt: "Kiplings creation" },
  { url: "/food/specialty.jpg", alt: "Kiplings specialty" },
  { url: "/food/dessert.jpg", alt: "Kiplings dessert" },
];

export const ProductScroller = () => {
  const allImages = [...productImages, ...productImages];

  return (
    <section className="py-16 bg-[#EEE8DC] overflow-hidden" data-testid="product-scroller-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-10">
        <div className="text-center">
          <p className="text-[#C9A85A] text-sm tracking-[0.2em] uppercase font-body font-semibold mb-3">
            Freshly Baked. European at Heart.
          </p>
          <h2 className="font-heading text-3xl md:text-4xl text-[#191646] font-medium tracking-tight">
            Our Creations
          </h2>
        </div>
      </div>

      <div className="relative">
        <div className="flex" style={{ width: "fit-content", animation: "scrollLeft 90s linear infinite" }}>
          {allImages.map((image, index) => (
            <div key={index} className="flex-shrink-0 w-64 h-64 md:w-72 md:h-72 mx-2 overflow-hidden group">
              <img loading="lazy" src={image.url} alt={image.alt} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
